import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { ProvidersDeleteDialog } from 'pages/Providers/components/ProvidersDeleteDialog/ProvidersDeleteDialog';
import { RaRecord, required, useEditController } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButtonValidated, DeleteButton } from 'shared/mui/Buttons';
import { BooleanInput, GenerateNameInput, TextInput } from 'shared/react-admin/Inputs';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Permission } from 'types/embedded/permission';
import { Provider } from 'types/embedded/provider';

import { ProvidersEditSkeleton } from './ProvidersEditSkeleton';

const transform = (data: RaRecord): RaRecord => {
  return {
    ...data,
    comment: data.comment || null,
  };
};

export const ProvidersEdit = (): JSX.Element => {
  const { goBack } = useGoBack();
  const { hasResourcePermissions } = usePermissions();
  const { record } = useEditController();
  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<Provider>();

  return (
    <>
      <EditGuesserPage
        leftActionsSlot={
          hasResourcePermissions(Resources.Providers, [Permission.Full, Permission.Delete]) ? (
            <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
          ) : undefined
        }
        listName="Провайдеры"
        mutationOptions={{ onError: () => undefined }}
        open={!openRecordModalDelete}
        rightActionsSlot={[
          <CancelButton key="cancel-button" onClick={goBack} variant="outlined" />,
          <SaveButtonValidated key="save-button" label="Сохранить" />,
        ]}
        skeleton={<ProvidersEditSkeleton />}
        title="Редактирование провайдера"
        transform={transform}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            width: '100%',
            gap: '4px 24px',
            padding: '24px 0',
          }}
        >
          <BooleanInput
            defaultValue={true}
            label="Активен"
            source="active"
            sx={{
              marginBottom: '24px',
              gridColumn: ' 1 / span 2',
            }}
          />
          <GenerateNameInput
            fullWidth
            label="Название"
            size="small"
            source="name"
            validate={required()}
            variant="outlined"
          />
          <TextInput
            fullWidth
            label="Алиас"
            size="small"
            source="alias"
            validate={required()}
            variant="outlined"
          />
          <TextInput
            fullWidth
            helperText={false}
            label="Комментарий"
            multiline
            size="small"
            source="comment"
            sx={{
              gridColumn: ' 1 / span 2',
            }}
            variant="outlined"
          />
        </Box>
      </EditGuesserPage>
      {openRecordModalDelete && (
        <ProvidersDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        >
          <CancelButton
            key="history-back-button"
            label="Вернуться к списку провайдеров"
            linkType="exit"
            variant="outlined"
          />
        </ProvidersDeleteDialog>
      )}
    </>
  );
};
